export const sources = {
	webp: "__VITE_ASSET__0PgJxXqjw$KAl6PgZjQb5g__ 500w, __VITE_ASSET__8Jdj9qQ4eJq3labUJOvRYQ__ 800w, __VITE_ASSET__e3FJByPCCgv8fip_DM$mWQ__ 1080w, __VITE_ASSET__HAwZnQ40A17rYC3Q$lxt9A__ 1600w, __VITE_ASSET__PWd8aapBt1YfLvgRaedarQ__ 2000w, __VITE_ASSET__V1ZYpwZc9C51fJhgOTS5xQ__ 2600w, __VITE_ASSET__RCaHVq_jCUoWDQWiWLxE3w__ 3200w, __VITE_ASSET__DzYsnjr1LtW1tBWqsYm2RQ__ 5100w"
};
export const img = {
	src: "__VITE_ASSET__DzYsnjr1LtW1tBWqsYm2RQ__",
	w: 5100,
	h: 3300
};
export default {
	sources: sources,
	img: img
};
